module.exports = __webpack_public_path__ + "1643e189871f3b3f5605880b607e2715.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgjyb_c.png
// module id = 270
// module chunks = 3